import { gql } from '@apollo/client';

export const GET_EMAIL_TEMPLATES = gql`
  query GET_EMAIL_TEMPLATES($ids: [ID!]) {
    emailTemplates(ids: $ids) {
      id
      emailId
      name
      description
      category
      subject
      senderEmail
      senderName
      to {
        id
        type
        ... on RoleRecipient {
          role {
            id
            name
          }
          level
        }
      }
      cc {
        id
        type
        ... on RoleRecipient {
          role {
            id
            name
          }
          level
        }
      }
      legends
      html
      disabled
    }
  }
`;

export const ADD_EMAIL_TEMPLATE = gql`
  mutation ADD_EMAIL_TEMPLATE($input: EmailTemplateInput!) {
    addEmailTemplate(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_EMAIL_TEMPLATE = gql`
  mutation UPDATE_EMAIL_TEMPLATE($id: ID!, $input: EmailTemplateInput!) {
    updateEmailTemplate(id: $id, input: $input) {
      id
      name
    }
  }
`;

export const DELETE_EMAIL_TEMPLATE = gql`
  mutation DELETE_EMAIL_TEMPLATE($id: ID!) {
    deleteEmailTemplate(id: $id) {
      id
      name
    }
  }
`;

export const TOGGLE_DISABLED_EMAIL_TEMPLATE = gql`
  mutation TOGGLE_DISABLED_EMAIL_TEMPLATE($id: ID!) {
    toggleDisabledEmailTemplate(id: $id) {
      id
    }
  }
`;
